import {useCallback,useEffect,useRef,useState} from 'react';
import useLectureExampleVoice from './useLectureExampleVoice';
import {createSpokenLectureExample} from './spokenLectureExample';

export default function useSpokenLectureExample({enabled=false,language='en-IN',disabled=false,onExample}) {
    const [capture,setCapture]=useState({draft:'',confirmedText:'',interimText:'',captureStatus:'idle',captureMessage:'',wordCount:0,canGenerate:false});
    const latest=useRef({enabled,disabled,onExample});latest.current={enabled,disabled,onExample};
    const engine=useRef(null);
    const createEngine=()=>createSpokenLectureExample({onChange:setCapture,onExample:text=>{
        if(!latest.current.enabled || latest.current.disabled || document.hidden)throw new Error('Voice capture is paused.');
        return latest.current.onExample?.(text);
    }});
    if(!engine.current)engine.current=createEngine();
    useEffect(()=>{
        if(!engine.current)engine.current=createEngine();
        const current=engine.current;
        return()=>{current.dispose();if(engine.current===current)engine.current=null;};
        // Effect setup recreates the disposed capture during StrictMode replay.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    const allowed=()=>latest.current.enabled && !latest.current.disabled;
    const final=useCallback(text=>{if(latest.current.enabled && !latest.current.disabled)engine.current.receiveFinal(text);},[]);
    const interim=useCallback(text=>{if(latest.current.enabled && !latest.current.disabled)engine.current.receiveInterim(text);},[]);
    const start=useCallback(()=>{if(latest.current.enabled && !latest.current.disabled)engine.current.speechStart();},[]);
    const end=useCallback(()=>{if(latest.current.enabled && !latest.current.disabled)engine.current.speechEnd();},[]);
    const voice=useLectureExampleVoice({enabled,language,disabled,onCommand:final,onInterim:interim,onSpeechStart:start,onSpeechEnd:end});
    useEffect(()=>{if(!enabled || disabled)engine.current.cancel();},[enabled,disabled]);
    useEffect(()=>{if(voice.status==='paused' || voice.status==='error' || voice.status==='unsupported')engine.current.pause();},[voice.status]);
    const generateNow=useCallback(value=>latest.current.enabled && !latest.current.disabled?engine.current?.generateNow(value) || false:false,[]);
    useEffect(()=>{engine.current?.cancel();},[language]);
    const cancelDraft=useCallback(()=>engine.current?.cancel(),[]);
    return {...voice,...capture,captureStatus:capture.captureStatus==='listening'?'capturing':capture.captureStatus,canGenerate:allowed() && capture.canGenerate,generateNow,cancelDraft};
}
